import { Model } from '../parents/model';

export class ImageModel extends Model {
  static ATTR_ID = 'id';
  static ATTR_NAME = 'name';
  static ATTR_EXTENSION = 'extension';
  static ATTR_WIDTH = 'width';
  static ATTR_HEIGHT = 'height';
  static ATTR_SIZE = 'size';
  static ATTR_MIME_TYPE = 'mime_type';
  static ATTR_CONTENT = 'content';
  static ATTR_STATUS = 'status';
  static ATTR_CREATED_AT = 'created_at';

  get name() {
    return this.attributes[ImageModel.ATTR_NAME];
  }

  get extension() {
    return this.attributes[ImageModel.ATTR_EXTENSION];
  }

  get width() {
    return this.attributes[ImageModel.ATTR_WIDTH];
  }

  get height() {
    return this.attributes[ImageModel.ATTR_HEIGHT];
  }

  get size() {
    return this.attributes[ImageModel.ATTR_SIZE];
  }

  get mimeType() {
    return this.attributes[ImageModel.ATTR_MIME_TYPE];
  }

  get content() {
    return this.attributes[ImageModel.ATTR_CONTENT];
  }

  get status() {
    return this.attributes[ImageModel.ATTR_STATUS];
  }

  get createdAt() {
    return this.attributes[ImageModel.ATTR_CREATED_AT];
  }
}
